//const refs = 'menu'
export default [
    {
        path: '/aboutus',
        name: 'aboutus',
        component: () => import('@/views/aboutus/List.vue')
    },
    {
        path: '/ourservices',
        name: 'services', 
        component: () => import('@/views/services/List.vue')
    },
    { 
        path: '/contactus',
        name: 'contactus',
        component: () => import('@/views/contactus/List.vue')
    }
]